import { Button, Checkbox, Divider, Grid, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import React, { useEffect, useState } from 'react'
import filterIcon from '../../Assets/filterIcon.svg'
import { AgencyPageStyle } from '../../Pages/agencies/agencyPageStyle'
import { AvailableProductsList } from '../../Models/tableDetailsModel'
import { useAgencyInfo } from '../../Context/agencyContext'

interface IProductFilterMenuProps {
    GetAgencyData: (start: string | null, end: string | null, productIds: string[] | null) => {}
}

const ProductFilterMenu = (props: IProductFilterMenuProps) => {

    const { GetAgencyData } = props
    const { productFilterList, setProductFilterList } = useAgencyInfo()

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [checkedList, setCheckedList] = useState<string[] | null>(null);

    const { filterButton, filterTitle, buttonItem } = AgencyPageStyle().classes

    const SetCheckboxDefaultValue = () => {
        let selectedIds: string[] = productFilterList?.map(prod =>
            (prod.flagSelected || prod.flagSelected === null) ? prod.productId : null
        ).filter((prod): prod is string => prod !== null) ?? [];
        setCheckedList(selectedIds);
    }

    useEffect(() => {
        if (checkedList === null && productFilterList !== null) {
            SetCheckboxDefaultValue()
        }
    }, [productFilterList]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        SetCheckboxDefaultValue()
    }

    const handleToggle = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, value: AvailableProductsList) => {
        setCheckedList(prev => {
            if (!prev) {
                return prev
            }
            return prev?.includes(value.productId) ?
                prev.filter((preObj) => preObj !== value.productId) : [...prev, value.productId]
        })
    };

    const applyFilters = () => {
        setProductFilterList(prev => {
            if (!prev) return prev
            const updatedList = prev.map((obj: AvailableProductsList) => (
                { ...obj, flagSelected: checkedList?.includes(obj.productId) ?? false }
            ));
            return updatedList;
        })
        GetAgencyData(null, null, checkedList)
        setAnchorEl(null);
    }

    const open = Boolean(anchorEl);

    return (
        <>
            <button
                className={filterButton}
                style={{ backgroundColor: anchorEl ? "#E7E7E7" : "#FFF" }}
                onClick={handleClick}
            >
                <img src={filterIcon} />
            </button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: {
                        width: '400px', // Or any width you want to set for the Popover
                    },
                }}
            >
                <Grid container justifyContent={"center"} gap={1}>
                    <Grid item xs={12} className={filterTitle}>
                        Product Filter
                    </Grid>
                    <Grid item xs={11.2}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        {productFilterList?.map((productDetail: AvailableProductsList) => {
                            return (
                                <ListItem
                                    key={productDetail.productId}
                                    disablePadding
                                >
                                    <ListItemButton role={undefined} onClick={(e) => { handleToggle(e, productDetail) }} dense>
                                        <ListItemIcon sx={{ minWidth: "0px" }}>
                                            <Checkbox
                                                edge="start"
                                                checked={checkedList?.includes(productDetail.productId)}
                                                disableRipple
                                                sx={{ padding: "3px 9px !important" }}
                                                inputProps={{ 'aria-labelledby': productDetail.productId.toString() }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={productDetail.productId.toString()} primary={`${productDetail.productName}`} />
                                    </ListItemButton>
                                </ListItem>
                            )
                        })}
                    </Grid>
                    <Grid item xs={12} className={buttonItem}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={applyFilters}
                            disabled={checkedList?.length === 0}
                        >
                            Apply
                        </Button>
                    </Grid>
                </Grid>
            </Popover>
        </>
    )
}

export default ProductFilterMenu